import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-perfilnuevo',
  templateUrl: './perfilnuevo.component.html',
  styles: []
})
export class PerfilnuevoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
